import RestForumAnswersByQuestionId from './queries/RestForumAnswersById';
import RestForumPostById from './queries/RestForumPostById';

export default RestForumPostById;

export const Providers = {
  Questions: RestForumPostById,
  Answers: RestForumAnswersByQuestionId,
  AnswerById: RestForumAnswersByQuestionId,
};
